import React, { useEffect, useState } from "react";
import Context from "../../context";
import copy from "copy-to-clipboard";
import DailyBonusModal from "./DailyBonusModal";
import ReferralModal from "./ReferralModal";

export default function MyAccount({ onClose }: { onClose: () => void }) {
  const { userInfo } = React.useContext(Context);
  const [tab, setTab] = useState<"overview"|"bonus"|"referral">("overview");
  const [bonusInfo, setBonusInfo] = useState<any>(null);
  const [showDaily, setShowDaily] = useState(false);
  const [showReferral, setShowReferral] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("aviator-token");
    if (!token) return;
    fetch("/api/my-referral", { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { if (d.status) setBonusInfo(d); })
      .catch(() => {});
  }, []);

  const handleCopy = () => {
    copy(`https://play.avitex.online?ref=${bonusInfo?.referralCode || ""}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const initials = (userInfo.userName || "P").slice(0, 2).toUpperCase();
  const wagerPct = bonusInfo?.bonusBalance
    ? Math.min(100, ((bonusInfo.bonusBalance * 5 - (bonusInfo.wagerRequired || 0)) / (bonusInfo.bonusBalance * 5)) * 100)
    : 0;

  const overlay: React.CSSProperties = {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)",
    zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center"
  };
  const modal: React.CSSProperties = {
    background: "linear-gradient(160deg,#1e1e38,#151525)",
    border: "1px solid #252545", borderRadius: "16px",
    width: "380px", maxWidth: "96vw", maxHeight: "90vh", overflowY: "auto",
    boxShadow: "0 24px 80px rgba(0,0,0,0.7)"
  };

  return (
    <>
      <div style={overlay}>
        <div style={modal}>
          {/* Header */}
          <div style={{ background: "linear-gradient(135deg,rgba(255,69,0,0.15),rgba(255,106,0,0.05))", padding: "24px 20px", borderBottom: "1px solid #252545", display: "flex", alignItems: "center", gap: "16px" }}>
            <div style={{ width: "52px", height: "52px", borderRadius: "50%", background: "linear-gradient(135deg,#ff4500,#ff6a00)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px", fontWeight: "bold", color: "#fff", flexShrink: 0 }}>
              {initials}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ color: "#fff", fontWeight: "bold", fontSize: "16px" }}>{userInfo.userName}</div>
              <div style={{ color: "#555", fontSize: "12px", marginTop: "2px" }}>KSh {Number(userInfo.balance).toFixed(2)} balance</div>
            </div>
            <button onClick={onClose} style={{ background: "rgba(255,255,255,0.05)", border: "1px solid #333", color: "#888", cursor: "pointer", fontSize: "18px", width: "28px", height: "28px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
          </div>

          {/* Tabs */}
          <div style={{ display: "flex", borderBottom: "1px solid #252545" }}>
            {([["overview","👤 Overview"],["bonus","🎁 Bonus"],["referral","🤝 Referral"]] as const).map(([t,l]) => (
              <button key={t} onClick={() => setTab(t as any)} style={{ flex: 1, padding: "12px 8px", border: "none", background: "transparent", cursor: "pointer", fontSize: "12px", fontWeight: "bold", color: tab === t ? "#ff4500" : "#555", borderBottom: tab === t ? "2px solid #ff4500" : "2px solid transparent" }}>{l}</button>
            ))}
          </div>

          <div style={{ padding: "20px" }}>
            {/* OVERVIEW TAB */}
            {tab === "overview" && (
              <div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "16px" }}>
                  {[["💰 Balance", `KSh ${Number(userInfo.balance).toFixed(2)}`, "#22c55e"],
                    ["🎁 Bonus", `KSh ${(bonusInfo?.bonusBalance || 0).toFixed(2)}`, "#ff4500"],
                  ].map(([l, v, c]) => (
                    <div key={l} style={{ background: "rgba(0,0,0,0.3)", border: "1px solid #252545", borderRadius: "10px", padding: "14px", textAlign: "center" }}>
                      <div style={{ color: "#555", fontSize: "10px", marginBottom: "4px", textTransform: "uppercase", letterSpacing: "0.8px" }}>{l}</div>
                      <div style={{ color: c, fontWeight: "bold", fontSize: "16px" }}>{v}</div>
                    </div>
                  ))}
                </div>

                {/* Quick Actions */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "16px" }}>
                  <button onClick={() => setShowDaily(true)} style={{ background: "linear-gradient(135deg,#7c3aed,#6d28d9)", border: "none", borderRadius: "10px", padding: "14px", color: "#fff", cursor: "pointer", textAlign: "center" }}>
                    <div style={{ fontSize: "24px", marginBottom: "4px" }}>🎰</div>
                    <div style={{ fontSize: "12px", fontWeight: "bold" }}>Daily Bonus</div>
                    <div style={{ fontSize: "10px", color: "rgba(255,255,255,0.6)", marginTop: "2px" }}>Claim KSh 50 free</div>
                  </button>
                  <button onClick={() => setShowReferral(true)} style={{ background: "linear-gradient(135deg,#0d9488,#0f766e)", border: "none", borderRadius: "10px", padding: "14px", color: "#fff", cursor: "pointer", textAlign: "center" }}>
                    <div style={{ fontSize: "24px", marginBottom: "4px" }}>🤝</div>
                    <div style={{ fontSize: "12px", fontWeight: "bold" }}>Refer Friends</div>
                    <div style={{ fontSize: "10px", color: "rgba(255,255,255,0.6)", marginTop: "2px" }}>Earn KSh 200 each</div>
                  </button>
                </div>

                {/* Referral code */}
                {bonusInfo?.referralCode && (
                  <div style={{ background: "rgba(0,0,0,0.3)", border: "1px solid #252545", borderRadius: "10px", padding: "14px" }}>
                    <div style={{ color: "#555", fontSize: "10px", marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.8px" }}>Your Referral Code</div>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <div style={{ flex: 1, background: "#0d0d1a", borderRadius: "6px", padding: "8px 12px", color: "#ff4500", fontWeight: "bold", letterSpacing: "2px", fontSize: "16px" }}>{bonusInfo.referralCode}</div>
                      <button onClick={handleCopy} style={{ background: "#ff4500", border: "none", borderRadius: "6px", padding: "8px 14px", color: "#fff", cursor: "pointer", fontSize: "12px", fontWeight: "bold" }}>{copied ? "✓" : "Copy"}</button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* BONUS TAB */}
            {tab === "bonus" && (
              <div>
                <button onClick={() => setShowDaily(true)} style={{ width: "100%", background: "linear-gradient(135deg,#ff4500,#ff6a00)", border: "none", borderRadius: "10px", padding: "16px", color: "#fff", cursor: "pointer", marginBottom: "16px", boxShadow: "0 4px 20px rgba(255,69,0,0.3)" }}>
                  <div style={{ fontSize: "28px", marginBottom: "6px" }}>🎁</div>
                  <div style={{ fontWeight: "bold", fontSize: "16px" }}>Claim Daily Bonus</div>
                  <div style={{ fontSize: "12px", opacity: 0.8, marginTop: "4px" }}>Free KSh 50 every 24 hours</div>
                </button>

                {bonusInfo?.bonusBalance > 0 ? (
                  <div style={{ background: "rgba(34,197,94,0.06)", border: "1px solid rgba(34,197,94,0.15)", borderRadius: "10px", padding: "16px" }}>
                    <div style={{ color: "#22c55e", fontWeight: "bold", marginBottom: "12px" }}>🔒 Active Bonus</div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px", fontSize: "13px" }}>
                      <span style={{ color: "#aaa" }}>Locked Bonus</span>
                      <span style={{ color: "#22c55e", fontWeight: "bold" }}>KSh {(bonusInfo.bonusBalance || 0).toFixed(2)}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px", fontSize: "13px" }}>
                      <span style={{ color: "#aaa" }}>Still to Wager</span>
                      <span style={{ color: "#ef4444", fontWeight: "bold" }}>KSh {(bonusInfo.wagerRequired || 0).toFixed(2)}</span>
                    </div>
                    <div style={{ background: "#1a1a3e", borderRadius: "4px", height: "8px" }}>
                      <div style={{ background: "linear-gradient(90deg,#ff4500,#ff6a00)", borderRadius: "4px", height: "8px", width: `${wagerPct}%`, transition: "width 0.5s" }} />
                    </div>
                    <div style={{ color: "#555", fontSize: "11px", marginTop: "8px", textAlign: "center" }}>Keep playing to unlock your bonus!</div>
                  </div>
                ) : (
                  <div style={{ textAlign: "center", color: "#555", padding: "20px 0", fontSize: "13px" }}>No active bonus — refer a friend or claim your daily bonus!</div>
                )}
              </div>
            )}

            {/* REFERRAL TAB */}
            {tab === "referral" && (
              <div>
                <div style={{ textAlign: "center", marginBottom: "20px" }}>
                  <div style={{ fontSize: "40px", marginBottom: "8px" }}>🤝</div>
                  <div style={{ color: "#fff", fontWeight: "bold", fontSize: "16px" }}>Earn KSh 200 per referral</div>
                  <div style={{ color: "#555", fontSize: "12px", marginTop: "4px" }}>Share your link. Friend deposits. Both win.</div>
                </div>
                {bonusInfo?.referralCode && (
                  <div style={{ marginBottom: "16px" }}>
                    <div style={{ color: "#aaa", fontSize: "11px", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.8px" }}>Your Referral Link</div>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <div style={{ flex: 1, background: "#0d0d1a", border: "1px solid #252545", borderRadius: "8px", padding: "10px 12px", color: "#666", fontSize: "11px", wordBreak: "break-all" }}>
                        play.avitex.online?ref={bonusInfo.referralCode}
                      </div>
                      <button onClick={handleCopy} style={{ background: "#ff4500", border: "none", borderRadius: "8px", padding: "10px 14px", color: "#fff", cursor: "pointer", fontSize: "12px", fontWeight: "bold" }}>{copied ? "✓ Copied" : "Copy"}</button>
                    </div>
                  </div>
                )}
                <div style={{ background: "rgba(255,69,0,0.06)", border: "1px solid rgba(255,69,0,0.15)", borderRadius: "10px", padding: "14px" }}>
                  <div style={{ color: "#ff4500", fontWeight: "bold", fontSize: "12px", marginBottom: "10px" }}>How it works</div>
                  {["Share your referral link", "Friend registers & makes first deposit", "Both of you get KSh 200 bonus!", "Wager KSh 1,000 to unlock the bonus"].map((s, i) => (
                    <div key={i} style={{ display: "flex", gap: "10px", marginBottom: "8px", fontSize: "12px", color: "#aaa" }}>
                      <span style={{ color: "#ff4500", fontWeight: "bold", width: "16px", flexShrink: 0 }}>{i + 1}.</span>
                      <span>{s}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showDaily && <DailyBonusModal onClose={() => setShowDaily(false)} />}
      {showReferral && <ReferralModal onClose={() => setShowReferral(false)} />}
    </>
  );
}
